/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssigneeListDtoFromJSON, AssigneeListDtoToJSON, ServiceStatusFromJSON, ServiceStatusToJSON, } from './';
export function ServiceTaskListDtoFromJSON(json) {
    return ServiceTaskListDtoFromJSONTyped(json, false);
}
export function ServiceTaskListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (new Date(json['startDateTime'])),
        'endDateTime': !exists(json, 'endDateTime') ? undefined : (new Date(json['endDateTime'])),
        'assignee': !exists(json, 'assignee') ? undefined : AssigneeListDtoFromJSON(json['assignee']),
        'status': !exists(json, 'status') ? undefined : ServiceStatusFromJSON(json['status']),
    };
}
export function ServiceTaskListDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime.toISOString()),
        'endDateTime': value.endDateTime === undefined ? undefined : (value.endDateTime.toISOString()),
        'assignee': AssigneeListDtoToJSON(value.assignee),
        'status': ServiceStatusToJSON(value.status),
    };
}
